/**
 * feAI – Frontend
 * src/main.tsx
 *
 * React application entry point.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/design-system.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
